import { AccordionProps, RendererProps } from '@/components/Accordion/types';

export const ACCORDION_PROPS: AccordionProps = {
  accordion: { className: 'w-full pb-8', style: { margin: 0 }, expanded: true },
  accordionSummary: {
    expandIcon: null,
    classes: { content: 'flex flex-col max-w-full' },
  },
};

export const RENDERER_PROPS: RendererProps = {
  bodyRendererProps: { className: 'w-full' },
};
